/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

// initial state
const state = {
  connected: false,
};

// getters
const getters = {};

// actions
const actions = {
  connected({ commit }) {
    // console.log('socket status: true');
    commit('connected');
  },
  disconnected({ commit }) {
    // console.log('socket status: false');
    commit('disconnected');
  },
};

// mutations
const mutations = {
  connected(state) {
    state.connected = true;
  },
  disconnected(state) {
    state.connected = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
